import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoggerService } from 'src/app/services/logger.service';
import { TourService } from 'src/app/services/tour.service';

@Component({
  selector: 'app-tour',
  templateUrl: './tour.component.html',
  styleUrls: ['./tour.component.css']
})

export class TourComponent implements OnInit {

  constructor(
    public logger: LoggerService
    , public tourService: TourService
  ) {
  }

  public ngOnInit(): void {
    
  }

  public skip(popover: any) {
    if (popover == null) {
      return;
    }
    //document.getElementsByClassName('layout-page')[0].classList.remove("tour-disable");
    //document.getElementsByClassName('layout-menu')[0].classList.remove("tour-disable");
    popover.close();
    setTimeout(() => {
      this.tourService.endTour();

    }, 200);
  }

  public next(popover: any) {
    if (popover == null) {
      return;
    }
    popover.close();
    setTimeout(() => {
      this.tourService.thisTourIndex++;
      this.tourService.next();
      popover.open();
    }, 200);
  }

}
